<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="评论名称">
          <el-input placeholder="请输入评论名称" v-model="formInline.search">
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="reast">重置</el-button>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" v-if="showBack" @click="gotoback">返回上一页</el-button>
        </el-form-item>
      </el-form>
    </div>

 

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="dynamic.name" label="评论标题"></el-table-column>
            <el-table-column prop="user.nickName" label="评论者">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.user.nickName }}({{ scope.row.user.user_id }})
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="content" label="内容"></el-table-column>
    
            <el-table-column prop="create_time" label="评论时间" width="150"></el-table-column>

            <el-table-column  label="是否公开" >
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_open" active-color="#13ce66" inactive-color="#ff4949"
               @change="isDefaultChange(scope.row)"></el-switch>
          
            </template>

          </el-table-column>   


            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    

  </div>
</template>

<script>
import DynamicApi from '@/api/dynamic.js';

  export default {
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },
        showBack:false,

      };
    },
    created() {
      this.formInline.search = this.$route.query.name;
      if(this.$route.query.name){
        this.showBack = true;
      }
      /*获取列表*/
      this.getTableList();
    },
    methods: {
        /* 设置默认 */
        isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let is_open = 1;
        if(row.is_open){
          is_open = 1;
        }else{
          is_open = 0;
        }
        self.loading = true;
        DynamicApi.setIsOpenDefault({dynamic_comment_id: row.dynamic_comment_id,is_open:is_open}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_open = !row.is_open
      })
    },
      reast(){
        this.formInline.search = ""
        this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
         /*返回上一页面*/
         gotoback(){
      this.$router.back(-1);
    },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        DynamicApi.comment(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

    
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DynamicApi.delComment(
              {
                dynamic_comment_id: row.dynamic_comment_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/dynamic/comment.vue